import React, { useState } from "react";
import styled from "styled-components";
import CaretIconToggle from "@common/Icons/CaretIconToggle";
import StackedButton from "@common/LifeAtButton/Variants/StackedButton";
import LifeAtDropdownMenu from "@common/LifeAtDropdownMenu/LifeAtDropdownMenu";
import Styles from "@themes/Styles";

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: auto;
`;

const LeftButton = styled(StackedButton)`
    padding: unset;
    margin: unset;
    border-radius: ${Styles.borderRadiusNormal} 0 0 ${Styles.borderRadiusNormal};
`;

const RightButton = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 0 ${Styles.borderRadiusNormal} ${Styles.borderRadiusNormal} 0;
    padding: 4px;

    &:hover {
        background: ${({ theme }) => theme.hoverPrimary};
    }
`;

const StyledDropdown = styled(LifeAtDropdownMenu)`
    position: absolute;
    bottom: 56px;
    left: 32px;
    border: 1px solid ${({ theme }) => theme.borderPrimary};
`;

interface LifeAtButtonWithDropdownProps {
    label: string;
    icon: React.ReactNode;
    dropdown: React.ReactNode;
    onClick?: () => void;
    className?: string;
}

export default function LifeAtButtonWithDropdown(props: LifeAtButtonWithDropdownProps) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    return (
        <Container className={props.className}>
            <LeftButton label={props.label} icon={props.icon} action={"click"} handleClick={props.onClick} />

            <RightButton onClick={() => setIsDropdownOpen((original) => !original)}>
                <CaretIconToggle showOpen={isDropdownOpen} />
            </RightButton>

            <StyledDropdown isOpen={isDropdownOpen} onClose={() => setIsDropdownOpen(false)}>
                <>{props.dropdown}</>
                <></>
            </StyledDropdown>
        </Container>
    );
}
